export const ExcludeFields = [" ","_id","id","codigo","id_autor","id_vitima","personagem_id","id_atendimento",
"avatar_file_patch","foto","ID_PROCEDIMENTO","id_endereco","id_natureza","id_endereco","id_veiculo","id_procedimento"]